import { isPathLocked } from '@constants/lockedModules';
import { useLockedModules } from '@hooks/useLockedModules';
import { LoadingOverlay } from '@mantine/core';
import React, { type FC } from 'react';
import { Navigate, useLocation } from 'react-router';

/**
 * Refuses routes outside the brand's plan, so a Premium screen cannot be reached by typing
 * its URL. Mounted once, around every brand-user route, and reading the same org config the
 * sidebar folds locked items under "Premium" with - the two can never disagree.
 *
 * Holds on the overlay until the plan is known rather than rendering the page first: a locked
 * screen that flashes before the redirect is a screen the brand has seen.
 */
const LockedModuleGate: FC<React.PropsWithChildren> = ({ children }) => {
    const location = useLocation();
    const { lockedModules, isLoading } = useLockedModules();

    if (isLoading) {
        return <LoadingOverlay visible />;
    }

    if (isPathLocked(lockedModules, location.pathname)) {
        return <Navigate to="/home" replace />;
    }

    return <>{children}</>;
};

export default LockedModuleGate;
